import { useState, useEffect } from 'react';

// 🎨 배경 이미지 로딩과 fallback을 처리하는 훅
export const useBackgroundImage = (imageUrl: string | null, fallback: string) => {
  const [currentImage, setCurrentImage] = useState<string>(fallback);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (!imageUrl) {
      setCurrentImage(fallback);
      setHasError(false);
      return;
    }

    setIsLoading(true);
    setHasError(false);

    // 이미지를 미리 로드해보기
    const img = new Image();
    
    img.onload = () => {
      setCurrentImage(imageUrl);
      setIsLoading(false);
    };

    img.onerror = () => {
      console.warn(`Failed to load background image: ${imageUrl}`);
      setCurrentImage(fallback);
      setHasError(true);
      setIsLoading(false);
    };

    img.src = imageUrl;

    // 클린업 함수
    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [imageUrl, fallback]);

  return {
    imageUrl: currentImage,
    isLoading,
    hasError
  };
};

// 배경 이미지 프리로딩 함수
export const preloadBackgroundImages = (imageUrls: string[]) => {
  imageUrls.forEach(url => {
    const img = new Image();
    img.src = url;
  });
};